import { Container, Grid, Paper, TableHead, Typography, Table, TableCell, TableBody, TableRow, TableContainer } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { withAuthorization } from "../Session";
import Chart from "react-google-charts";
import { green, orange, red } from "@material-ui/core/colors";
import EvaluationDatesChart from "./EvaluationDatesChart";
import { Cancel, CheckCircle } from "@material-ui/icons";
import { CircularProgress } from "@material-ui/core";

const ManagerPage = (props) => {
  const { firebase } = props;
  const [usersReports, setUsersReports] = useState({});
  const [usersList, setUsersList] = useState({});
  const [loaded, setLoaded] = useState(false);
  const [viewUid, setViewUid] = useState(false);
  const [activeRescuers, setActiveRescuers] = useState(0);
  const [totalRescuers, setTotalRescuers] = useState(0);
  const [reportsData, setReportsData] = useState({
    inProgress: 0,
    withoutStart: 0,
    finished: 0,
    passed: 0,
    NoPassed: 0,
  });

  useEffect(() => {
    firebase
      //.managerUsers(firebase.currentUser().uid)
      .reports()
      .once("value")
      .then((snap) => {
        setUsersReports(snap.val());
        firebase
          .users()
          .once("value")
          .then((users) => {
            setUsersList(users.val());
            console.log("l1", users.val());
            let activeRescuers = 0;
            let userList = Object.keys(users.val());
            userList.forEach((user) => {
              users.val()[user].sgpfc.rescuer && activeRescuers++;
            });
            setActiveRescuers(activeRescuers);
            setTotalRescuers(userList.length);
            requestAnimationFrame(() => setLoaded(true));
          });
      });
  }, []);

  return (
    <Container>
      <Grid container spacing={4}>
        <Grid item xs={12} style={{ marginTop: 32 }}>
          <Typography variant="h4" color="primary">
            Gestión de resultados
          </Typography>
          <Typography variant="h5" color="textSecondary">
            Grupo de Ermua
          </Typography>
        </Grid>

        <Grid item xs={12} lg={5}>
          <Paper style={{ height: "100%" }}>
            <EvaluationDatesChart />
          </Paper>
        </Grid>

        <Grid item xs={12} lg={3}>
          <Paper style={{ height: "100%", backgroundColor: "#2e7d32" }}>
            <Typography style={{ paddingTop: 12, paddingLeft: 12, color: "white" }} variant="h6">
              Rescatador@s activos
            </Typography>
            <Grid container item xs={12} alignItems="center" justify="center" style={{ height: "80%" }}>
              <Typography variant="h1" style={{ justifySelf: "center", color: "white" }}>
                {activeRescuers}
              </Typography>
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12} lg={4}>
          <Paper style={{ maxHeight: "100%", padding: 18 }}>
            <Chart
              height={"100%"}
              chartType="PieChart"
              loader={<div>Loading Chart</div>}
              data={[
                ["Task", "Hours per Day"],
                ["Superadas", 11],
                ["En curso", 2],
                ["Suspendidas", 5],
              ]}
              options={{
                title: "Estado de Formaciones",
                width: "100%",
                forceIframe: true,
                pieHole: 0.8,
                colors: [green[400], orange[400], red[400]],
                chartArea: { left: 0, top: 40, width: "100%", height: "100%" },
                pieSliceText: "none",
                pieStartAngle: -90,
                legend: {
                  position: "labeled",
                  alignment: "center",
                  textStyle: { fontSize: 12, fontName: "Roboto" },
                },
                titleTextStyle: { fontSize: 18, fontName: "Roboto" },
                tooltip: {
                  textStyle: { fontSize: 22, fontName: "Roboto" },
                  trigger: "selection",
                },
              }}
              rootProps={{ "data-testid": "3" }}
            />
          </Paper>
        </Grid>
        <Grid item xs={12}>
          {loaded ? (
            <TableContainer
              component={Paper}
              style={{
                maxHeight: "42vh",
                overflowY: "auto",
                overflowX: "auto",
              }}
            >
              <Table style={{ minWidth: 1200 }}>
                <TableHead>
                  <TableRow>
                    <TableCell align="center" colSpan={2} style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}></TableCell>
                    <TableCell align="center" colSpan={3} style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                      Fase 1
                    </TableCell>
                    <TableCell align="center" colSpan={3} style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                      Fase 2
                    </TableCell>
                    <TableCell align="center" colSpan={3} style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                      Fase 3
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    {["Email", "Nombre", "Formad@", "Aprovad@", "Intentos", "Formad@", "Aprovad@", "Intentos", "Formad@", "Aprovad@", "Intentos"].map((text, i) => (
                      <TableCell key={i} align={i > 1 ? "right" : "left"} style={{ position: "sticky", top: 40, background: "#fff", zIndex: 1 }}>
                        {text}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.keys(usersList).map((uid) => (
                    <UserReportRow key={uid} userInfo={usersList[uid]} userReport={usersReports[uid]} uid={uid} viewUid={viewUid} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Grid container justifyContent="center" style={{ padding: 40 }}>
              <CircularProgress color="primary" />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

const UserReportRow = ({ userInfo, userReport, uid, viewUid }) => {
  const [courses, setCourses] = useState({ c1: false, c2: false, c3: false });
  const [test, setTest] = useState({
    ECS1: { passed: false, attemps: 0 },
    ECS2: { passed: false, attemps: 0 },
    ECS3: { passed: false, attemps: 0 },
  });

  useEffect(() => {
    if (userReport !== undefined) {
      if (userReport?.courses !== undefined) {
        setCourses({
          c1: userReport?.courses.FCSReconocimientoPrecoz !== undefined ? userReport?.courses.FCSReconocimientoPrecoz : false,
          c2: userReport?.courses.FCSRCPPrecoz !== undefined ? userReport?.courses.FCSRCPPrecoz : false,
          c3: userReport?.courses.FCSDesfibrilacionPrecoz !== undefined ? userReport?.courses.FCSDesfibrilacionPrecoz : false,
        });
      }
      if (userReport.tests !== undefined) {
        //console.log(userReport.tests, uid);
        setTest({
          ECS1: {
            passed: userReport.tests.ECS1.metadata.evalApproved,
            attemps: userReport.tests.ECS1.metadata.nAttemps + 1,
          },
          ECS2: {
            passed: userReport.tests.ECS2.metadata.evalApproved,
            attemps: userReport.tests.ECS2.metadata.nAttemps + 1,
          },
          ECS3: {
            passed: userReport.tests.ECS3.metadata.evalApproved,
            attemps: userReport.tests.ECS3.metadata.nAttemps + 1,
          },
        });
      }
    }
  }, []);

  //userInfo.info.email == undefined && console.log(userInfo, uid);

  return (
    <TableRow key={uid}>
      <TableCell>{userInfo?.info?.email}</TableCell>
      <TableCell>{uid}</TableCell>
      <TableCell align="right">{courses.c1 ? <CheckCircle style={{ color: green[500] }} /> : <Cancel style={{ color: red[500] }} />}</TableCell>
      <TableCell align="right">{test?.ECS1?.passed ? <CheckCircle style={{ color: green[500] }} /> : <Cancel style={{ color: red[500] }} />}</TableCell>
      <TableCell align="right">{test?.ECS1?.attemps}</TableCell>

      <TableCell align="right">{courses.c2 ? <CheckCircle style={{ color: green[500] }} /> : <Cancel style={{ color: red[500] }} />}</TableCell>
      <TableCell align="right">{test?.ECS2?.passed ? <CheckCircle style={{ color: green[500] }} /> : <Cancel style={{ color: red[500] }} />}</TableCell>
      <TableCell align="right">{test?.ECS2?.attemps}</TableCell>

      <TableCell align="right">{courses.c3 ? <CheckCircle style={{ color: green[500] }} /> : <Cancel style={{ color: red[500] }} />}</TableCell>
      <TableCell align="right">{test?.ECS3?.passed ? <CheckCircle style={{ color: green[500] }} /> : <Cancel style={{ color: red[500] }} />}</TableCell>
      <TableCell align="right">{test?.ECS3?.attemps}</TableCell>
    </TableRow>
  );
};

const UserReportRow2 = ({ userInfo, userReport, uid, viewUid }) => {
  const [courses, setCourses] = useState({ c1: false, c2: false, c3: false });
  const [test, setTest] = useState({
    ECS1: { passed: false, attemps: 0 },
    ECS2: { passed: false, attemps: 0 },
    ECS3: { passed: false, attemps: 0 },
  });

  useEffect(() => {
    if (userReport !== undefined) {
      if (userReport?.courses !== undefined) {
        setCourses({
          c1: userReport?.courses?.FCSReconocimientoPrecoz !== undefined ? userReport?.courses?.FCSReconocimientoPrecoz : false,
          c2: userReport?.courses?.FCSRCPPrecoz !== undefined ? userReport?.courses?.FCSRCPPrecoz : false,
          c3: userReport?.courses?.FCSDesfibrilacionPrecoz !== undefined ? userReport?.courses?.FCSDesfibrilacionPrecoz : false,
        });
      }
      if (userReport.tests !== undefined) {
        setTest({
          ECS1: {
            passed: userReport.tests.ECS1.metadata.evalApproved,
            attemps: userReport.tests.ECS1.metadata.nAttemps + 1,
          },
          ECS2: {
            passed: userReport.tests.ECS2.metadata.evalApproved,
            attemps: userReport.tests.ECS2.metadata.nAttemps + 1,
          },
          ECS3: {
            passed: userReport.tests.ECS3.metadata.evalApproved,
            attemps: userReport.tests.ECS3.metadata.nAttemps + 1,
          },
        });
      }
    }
  }, []);

  //userInfo.info.email == undefined && console.log(userInfo, uid);

  return (
    <p>{`${userInfo?.info?.email},${userInfo?.info?.name},${courses?.c1},${test?.ECS1?.passed},${test?.ECS1?.attemps},${courses?.c2},${test?.ECS2?.passed},${test?.ECS2?.attemps},${courses?.c3},${test?.ECS3?.passed},${test?.ECS3?.attemps}`}</p>
  );
};

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(ManagerPage);
